import './App.css';
import Dashboard from './pages/Dashboard';
import Header from './components/Header';


function App() {

  return (
    <div className="container">
      <Header />
      <Dashboard />
    </div>
    
  );
}

export default App;
